import { Redirect } from 'react-router-dom';
import { useDefaultYoutubeNativeStation } from '../stations/hooks/useDefaultYoutubeNativeStation';

/**
 * Redirects to the default YouTube Native station list path, or to logger status when none exist.
 */
export function DefaultYoutubeNativeStationRedirect({
  to,
}: {
  to: (stationSlug: string) => string;
}) {
  const defaultStation = useDefaultYoutubeNativeStation();

  if (!defaultStation) {
    return <Redirect to="/logger/status" />;
  }

  return <Redirect to={to(defaultStation.slug)} />;
}
